<template>
  <div id="survey-builder-dashboard">
    <div class="row border-bottom white-bg dashboard-header campaign-header">
      <div class="col-lg-12">
        <h2 style="display: block">Survey Builder Dashboard</h2>

        <survey-filter class="pull-left" style="display: inline" />
      </div>
    </div>
    <div class="wrapper wrapper-content animated fadeInRight">
      <div class="row" v-if="surveyListLoading">
        <div class="col-lg-12">
          <loader message="Loading surveys" />
        </div>
      </div>

      <div class="row" v-if="!surveyListLoading && surveyList && !surveyList.length">
        <div class="col-lg-12">
          <div class="empty">No surveys found within the current filter.</div>
        </div>
      </div>

      <div class="row" v-if="!surveyListLoading">
        <div class="col-lg-12">
          <survey-list-item
            v-for="survey in surveyList"
            :key="survey.id"
            :id="parseInt(survey.id, 10)"
            :title="survey.title"
            :state="determineSurveyState(survey)"
            :growth="survey.growth"
            :totalEntries="survey.totalEntries"
            :totalThisMonth="survey.totalEntriesThisMonth"
            :totalPerDayThisMonth="survey.totalPerDayThisMonth"
            :progress="calculateProgress(survey)"
            :isSpotSurvey="survey.isSpot"
            :favorite="survey.favorite"
            :isPreview="survey.isPreview"
            :startDate="moment(survey.startDate)"
            :endDate="moment(survey.endDate)"
            :createdBy="survey.createdBy"
            :editable="true"
            :isAdminUser="me.is_staff"
            @onDownloadMessages="handleDownloadMessages(survey)"
            @onEditSurvey="handleEditSurvey(survey)"
            @onViewSurvey="handleViewSurvey(survey)"
            @onToggleActiveStatus="handleToggleLiveStatus($event, survey.id)"
          />
          <empty v-if="surveyList.length == 0">No surveys found.</empty>

          <div class="text-center" v-if="surveyListTotalPages > 1">
            <paginator
              id="paginator"
              :pages="surveyListTotalPages"
              :currentPage="surveyListPage"
              v-if="surveyList.length"
              @goToNextPage="handleNextPage"
              @goToPreviousPage="handlePreviousPage"
              @goToPage="handleGoToPage"
            ></paginator>
          </div>
        </div>
      </div>
    </div>
    <fab-speed-dial
      position-type="fixed"
      icon-size="small"
      mainTooltip="New Survey"
      @click="handleCreateSurvey"
    />
  </div>
</template>

<script>
import moment from 'moment';
import { mapState } from 'vuex';

import Loader from '@/components/common/Loader';
import Empty from '@/components/common/Empty';
import Paginator from '@/components/common/Paginator';
import FabSpeedDial from '@/components/common/FabSpeedDial';

import SurveyFilter from '@/components/surveybuilder/SurveyFilter';
import SurveyListItem from '@/components/surveybuilder/SurveyListItem';

export default {
  name: 'SurveyBuilderDashboard',
  components: {
    SurveyFilter,
    SurveyListItem,
    Empty,
    Loader,
    FabSpeedDial,
    Paginator,
  },
  data: () => ({
    moment,
    currentFilter: {
      title: null,
      state: 'ALL',
    },
  }),
  mounted() {
    this.$store.dispatch('surveybuilder/listSurveys');
  },
  computed: {
    ...mapState('user', ['me']),
    ...mapState('surveybuilder', [
      'surveyList',
      'surveyListLoading',
      'surveyListPage',
      'surveyListTotalPages',
    ]),
  },
  methods: {
    calculateProgress(survey) {
      const currentTime = new Date().getTime();
      const endTime = new Date(survey.endDate).getTime();
      return parseInt((currentTime / endTime) * 100, 10);
    },

    determineSurveyState(survey) {
      if (survey.isPreview) {
        return 'IS_PREVIEW';
      } else if (!survey.isActive) {
        return 'IS_INACTIVE';
      }
      return 'IS_ACTIVE';
    },

    handleNextPage() {
      this.$store.dispatch('surveybuilder/listSurveysNextPage');
    },

    handlePreviousPage() {
      this.$store.dispatch('surveybuilder/listSurveysPrevPage');
    },

    handleGoToPage(page) {
      this.$store.dispatch('surveybuilder/listSurveysGoToPage', page);
    },

    handleCreateSurvey() {
      this.$router.push('surveyBuilder/editor');
    },

    handleEditSurvey(survey) {
      this.$router.push(`surveybuilder/editor/${survey.id}`);
    },
  },
};
</script>
<style lang="scss" scoped>
.surveys-table-container {
  margin: 10px 0;
}
.active-dot {
  padding-left: 25px;
}

.empty {
  text-align: center;
  font-size: 1.6em;
  color: #ccc;
  text-shadow: 2px 2px 2px #efefef;
}
</style>



// WEBPACK FOOTER //
// SurveyBuilderDashboard.vue?09763b98